import { QueryKey } from "react-query";

export const createUseAvailabilityMapKey = ({
  length = 30,
  serviceItemId,
  clinicId,
  date,
  healthPlanId,
}: {
  date: string;
  clinicId: string;
  serviceItemId: string[];
  length: number;
  healthPlanId?: string;
}): QueryKey => [
  "useAvailabilityMapKey",
  clinicId,
  length,
  serviceItemId,
  date,
  healthPlanId,
];

export const createUseAvailabilityTimeKey = ({
  serviceItemId,
  clinicId,
  date,
  healthPlanId,
}: {
  date: string;
  clinicId: string;
  serviceItemId: string[];
  healthPlanId?: string;
}): QueryKey => [
  "useAvailabilityTimeKey",
  clinicId,
  serviceItemId,
  date,
  healthPlanId,
];
